import React, { forwardRef } from 'react'
import { ActivityIndicator } from 'react-native'

import { colors } from '../../tokens'
import { type ButtonType } from '../button'

type SpinnerRef = React.ComponentRef<typeof ActivityIndicator>
export type ButtonSpinnerProps = React.ComponentPropsWithoutRef<typeof ActivityIndicator> & {
    type?: ButtonType
}

// `ActivityIndicator` takes a colour VALUE and ignores a className, so the
// contract's label class cannot reach it the way it reaches a glyph. The ink is
// mirrored here as the matching token instead.
const SPINNER_COLOR: Record<ButtonType, string> = {
    primary: colors.content['on-primary'],
    destructive: colors.content.knockout,
    secondary: colors.content.default,
    text: colors.content.default,
}

export const ButtonSpinner = forwardRef<SpinnerRef, ButtonSpinnerProps>(
    ({ color, type = 'primary', ...rest }, ref) => (
        <ActivityIndicator ref={ref} color={color ?? SPINNER_COLOR[type]} {...rest} />
    ),
)
ButtonSpinner.displayName = 'ButtonSpinner'
